import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Initialize with 2 hours in seconds
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return {
      h,
      m,
      s
    };
  };
  const {
    h,
    m,
    s
  } = formatTime(timeLeft);
  return <div className="w-full max-w-md mx-auto bg-gradient-to-br from-[#3A3A3A] to-[#2A2A2A] rounded-2xl p-6 shadow-xl border border-[#C9A86A]/30" data-id="element-201">
      <div className="flex items-center justify-center gap-2 mb-4 text-[#C9A86A]" data-id="element-202">
        <Clock className="w-5 h-5" data-id="element-203" />
        <span className="font-medium tracking-wide uppercase text-sm" data-id="element-204">
          La Oferta Termina En
        </span>
      </div>

      <div className="grid grid-cols-3 gap-4 text-center" data-id="element-205">
        <div className="flex flex-col" data-id="element-206">
          <div className="bg-[#C9A86A] rounded-xl p-4 shadow-lg" data-id="element-207">
            <span className="text-4xl font-serif font-bold text-white" data-id="element-208">
              {h.toString().padStart(2, '0')}
            </span>
          </div>
          <span className="text-xs text-gray-400 mt-2 uppercase tracking-wider" data-id="element-209">
            Horas
          </span>
        </div>

        <div className="flex flex-col" data-id="element-210">
          <div className="bg-[#C9A86A] rounded-xl p-4 shadow-lg" data-id="element-211">
            <span className="text-4xl font-serif font-bold text-white" data-id="element-212">
              {m.toString().padStart(2, '0')}
            </span>
          </div>
          <span className="text-xs text-gray-400 mt-2 uppercase tracking-wider" data-id="element-213">
            Minutos
          </span>
        </div>

        <div className="flex flex-col" data-id="element-214">
          <div className="bg-[#C9A86A] rounded-xl p-4 shadow-lg" data-id="element-215">
            <span className="text-4xl font-serif font-bold text-white" data-id="element-216">
              {s.toString().padStart(2, '0')}
            </span>
          </div>
          <span className="text-xs text-gray-400 mt-2 uppercase tracking-wider" data-id="element-217">
            Segundos
          </span>
        </div>
      </div>
    </div>;
}